import React from "react";

import { ReactComponent as GraceLockIcon } from "../../../assets/images/common/GraceLock.svg";

import "./LockedValue.css";

const LOCKED_LABEL = "Status locked until payment is completed";
const FAKE_STATUS_SEGMENTS = [
  { width: 36, color: "var(--color-content-negative)" },
  { width: 52, color: "var(--color-content-positive)" },
  { width: 12, color: "var(--color-content-warning)" },
];

export default function LockedValue({
  locked = false,
  children,
  blur = true,
  showLabel = false,
  label = LOCKED_LABEL,
  // "value" | "bar"
  variant = "value",
  className = "",
}) {
  if (!locked) {
    return children;
  }

  const isBar = variant === "bar";

  return (
    <span
      className={`LockedValue${blur ? " LockedValue--blur" : ""}${isBar ? " LockedValue--bar" : ""} ${className}`.trim()}
    >
      {blur && isBar && (
        <span className="LockedValue__BarBackdrop" aria-hidden>
          {FAKE_STATUS_SEGMENTS.map((segment) => (
            <span
              key={segment.color}
              className="LockedValue__BarSegment"
              style={{
                width: `${segment.width}%`,
                backgroundColor: segment.color,
              }}
            />
          ))}
        </span>
      )}
      {blur && !isBar && (
        <span className="LockedValue__Blur" aria-hidden>88.8</span>
      )}
      <GraceLockIcon className="LockedValue__Icon" aria-hidden />
      {showLabel && label && (
        <span className="LockedValue__Label">{label}</span>
      )}
    </span>
  );
}
